<script setup lang="ts">
useDefaultMeta({
  title: 'Cek ongkir JNE, J&T, SiCepat, Ninja, POS, Tiki, IDExpress Terlengkap',
  description:
    'Cek tarif ongkos kirim JNE, J&amp;T, SAP, JDL, SiCepat, POS, Sentral Cargo, NCS, ID Express, Ninja Xpress, AnterAja. Tarif paling update, akurat dan cepat.',
  schema: {
    title: 'Cek Ongkir'
  }
})
</script>
<template>
  <CekajaHero />
  <PresetCourier />
  <CekajaFAQ />
  <CtaSection />
</template>
